import {
  Box,
  ButtonIcon,
  Dropdown,
  ListGroup,
} from '@cubeyou-team/hx-react-components';
import React, {
  FC,
  useCallback,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

export const MORE_ACTIONS_POSITIONS = {
  TOP_RIGHT: 'top-right',
} as const;

type MoreActionsItems =
  | React.ReactNode[]
  | ((closeDropdown: () => void) => React.ReactNode[]);

interface MoreActionsProps {
  items: MoreActionsItems;
  variant?: 'light' | 'dark';
  onOpenChange?: (isOpen: boolean) => void;
}
export const MoreActions: FC<MoreActionsProps> = ({
  items,
  variant = 'light',
  onOpenChange,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [dropDownPosition, SetDropDownPosition] = useState('right');
  const [isHistoryDropdownOpen, setIsHistoryDropdownOpen] = useState(false);

  const setDropdownOpen = useCallback(
    (isOpen: boolean) => {
      setIsHistoryDropdownOpen(isOpen);
      onOpenChange?.(isOpen);
    },
    [onOpenChange]
  );

  const closeDropdown = useCallback(() => {
    setDropdownOpen(false);
  }, [setDropdownOpen]);

  const resolvedItems =
    typeof items === 'function' ? items(closeDropdown) : items;

  useLayoutEffect(() => {
    if (
      containerRef.current?.getBoundingClientRect().y >
      window.innerHeight * 0.8
    )
      SetDropDownPosition(MORE_ACTIONS_POSITIONS.TOP_RIGHT);
  }, []);

  const onClickOutside = useCallback(() => closeDropdown(), [closeDropdown]);

  return (
    <>
      <div ref={containerRef} className="relative z-10">
        <Dropdown
          isOpen={isHistoryDropdownOpen}
          position={dropDownPosition}
          content={
            <Box pX="small" pT="small">
              <ListGroup items={resolvedItems} />
            </Box>
          }
          onClickOutside={onClickOutside}
        >
          <ButtonIcon
            size="small"
            icon="more"
            variant={variant}
            onClick={(e) => {
              e.stopPropagation();
              setDropdownOpen(true);
            }}
          />
        </Dropdown>
      </div>
    </>
  );
};
